import React, { useId } from 'react';
import { useForm } from 'react-hook-form';

import { CamposFiltro } from './styles';
import Modal from '../Modal';
import Button from '../Button';
import { Campo, InputPorTipo } from '../FichaCadastroGenerico';
import { Filtros } from '../../hooks/useFiltrosDashboard';
import { tratarPayload } from '../../utils/payload';

interface ModalFiltrosProps {
  titulo: string;
  /** Campos do laytel do relatório, já sem os ocultos do dashboard */
  campos: Campo[];
  filtros: Filtros;
  onAplicar: (filtros: Filtros) => void;
  /** Volta aos filtros padrão, mantendo o período */
  onLimpar: () => void;
  onClose: () => void;
}

// Valor inicial de cada campo no formato do input (data YYYY-MM-DD, checkbox booleano,
// select na primeira opção se nunca foi escolhido)
function valoresIniciais(campos: Campo[], filtros: Filtros) {
  return campos.reduce<Record<string, any>>((acc, campo) => {
    const valor = filtros[campo.campo] ?? '';
    if (campo.tipinp === 'checkbox') acc[campo.campo] = valor === '1';
    else if (campo.tipinp === 'select') acc[campo.campo] = valor || campo.opcoes?.[0]?.valor || '';
    else if ((campo.tipinp as string) === 'date') acc[campo.campo] = valor.split('/').reverse().join('-');
    else acc[campo.campo] = valor;
    return acc;
  }, {});
}

// Filtros do dashboard montados pelo laytel (os mesmos da tela do relatório)
export default function ModalFiltros({ titulo, campos, filtros, onAplicar, onLimpar, onClose }: ModalFiltrosProps) {
  const idForm = useId();
  const { register, handleSubmit, watch, setValue } = useForm<any>({
    defaultValues: valoresIniciais(campos, filtros)
  });

  // Busca com código 0 (vazio, ex.: codven) não deve pré-selecionar nada
  const dados = Object.fromEntries(Object.entries(filtros).filter(([, valor]) => valor !== '0'));

  function aplicar(valores: Record<string, any>) {
    const tratados = tratarPayload(valores);
    onAplicar(Object.fromEntries(Object.entries(tratados).map(([chave, valor]) => [chave, String(valor ?? '')])));
  }

  return (
    <Modal
      titulo={titulo}
      onClose={onClose}
      rodape={
        <>
          <Button variante='fantasma' texto='Limpar filtros' onClick={onLimpar} disabled={campos.length === 0} />
          <Button variante='secundario' texto='Cancelar' onClick={onClose} />
          <Button type='submit' form={idForm} texto='Aplicar' disabled={campos.length === 0} />
        </>
      }
    >
      {campos.length === 0 ? (
        <p>Sem filtros cadastrados para este dashboard.</p>
      ) : (
        <form id={idForm} onSubmit={handleSubmit(aplicar)}>
          <CamposFiltro>
            {campos.map((campo, index) => (
              <InputPorTipo
                key={campo.campo}
                tipo={campo.tipinp}
                campo={campo}
                index={index}
                dados={dados}
                register={register}
                watch={watch}
                setValue={setValue}
                relatorio
              />
            ))}
          </CamposFiltro>
        </form>
      )}
    </Modal>
  );
}
